import * as CSS from 'csstype';
import styled, { StyledComponent } from 'styled-components';
import {
  system,
  space,
  layout,
  color,
  flexbox,
  grid,
  background,
  border,
  position,
  shadow,
  SpaceProps,
  ColorProps,
  LayoutProps,
  FlexboxProps,
  BackgroundProps,
  BorderProps,
  PositionProps,
  ShadowProps,
  TypographyProps,
  typography,
  GridProps,
} from 'styled-system';
import css from '@styled-system/css';
import rem from '../../../utils/rem';

export type BoxProps = SpaceProps &
  ColorProps &
  LayoutProps &
  FlexboxProps &
  BackgroundProps &
  BorderProps &
  PositionProps &
  TypographyProps &
  GridProps &
  ShadowProps & {
    className?: string;
    whiteSpace?: CSS.Property.WhiteSpace;
    boxSizing?: CSS.Property.BoxSizing;
    outline?: 'none';
    transform?: CSS.Property.Transform;
    cursor?: CSS.Property.Cursor;
    textDecoration?: CSS.Property.TextDecoration;
    pointerEvents?: CSS.Property.PointerEvents;
    zoom?: CSS.Property.Zoom;
  };

type TBox = StyledComponent<'div', any, BoxProps>;

export const Box: TBox = styled.div<BoxProps>`
  position: relative;
  box-sizing: border-box;
  ${space}
  ${layout}
  ${background}
  ${color}
  ${border}
  ${position}
  ${typography}
  ${shadow}
  ${flexbox}
  ${grid}
  ${system({
    whiteSpace: true,
    boxSizing: true,
    outline: true,
    transform: true,
    cursor: true,
    textDecoration: true,
    pointerEvents: true,
    zoom: true,
  })}
`;

export const Flex = styled(Box)`
  display: flex;
  flex: 1 1 auto;
  ${flexbox}
`;

export const ShadowBox = styled(Box)`
  ${css({
    borderRadius: 'small',
    bg: 'light',
    boxShadow: 'box',
  }) as any}
`;

export const GreyBox = styled(Box)`
  ${css({
    borderRadius: 'small',
    bg: 'alabaster',
    p: 'large',
  }) as any}
  ${space}
`;

export const Grid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-column-gap: ${rem(32)};
  ${grid}
`;
